import { INVOICE_TYPE_LABELS, type InvoiceType } from '@/modules/billing/types';

const TYPE_CLASS: Record<InvoiceType, string> = {
  internal: 'billing-type--internal',
  fiscal: 'billing-type--fiscal',
};

type InvoiceTypeBadgeProps = {
  type: InvoiceType;
};

export function InvoiceTypeBadge({ type }: InvoiceTypeBadgeProps) {
  return (
    <span className={`billing-type ${TYPE_CLASS[type]}`}>
      {INVOICE_TYPE_LABELS[type]}
    </span>
  );
}
